import { render, staticRenderFns } from "./SubscriptionsView.vue?vue&type=template&id=2682bc44&scoped=true"
import script from "./SubscriptionsView.vue?vue&type=script&lang=js"
export * from "./SubscriptionsView.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionsView.vue?vue&type=style&index=0&id=2682bc44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2682bc44",
  null
  
)

export default component.exports